import ProjectOverview from "./pages/ProjectOverview";
import Project from "./pages/Project";
import { Redirect, Switch } from "react-router-dom";
import { lazy } from "react";
import { ProjectsHeader } from "./pages/Projects/components/Header";
import { PageWrapper } from "./components/PageWrapper/PageWrapper";
import { routes } from "./utils/constants";
import { DepartmentHeader } from "./pages/DepartmentOverview/components/Header";
//import LeanerIconsPreview from "./pages/LeanerIconsPreview";

const Projects = lazy(() => import("./pages/Projects"));
const ReplaceRedirect = lazy(() => import("./pages/ReplaceRedirect"));
const SyncStatusDetails = lazy(() => import("./pages/SyncStatusDetails"));
const SyncStatus = lazy(() => import("./pages/SyncStatus"));
const Settings = lazy(() => import("./pages/Settings"));
const Login = lazy(() => import("./pages/Login"));
const DepartmentOverview = lazy(() => import("./pages/DepartmentOverview"));

export const RoutesWrapper = () => {
  return (
    <Switch>
      <PageWrapper path={routes.settings} Component={Settings} />
      <PageWrapper path={routes.departmentOverview} Component={DepartmentOverview} Header={DepartmentHeader} />
      <PageWrapper path={routes.totalProjectOverview} Component={ProjectOverview} />
      <PageWrapper path={routes.project} Component={Project} />
      <PageWrapper path={routes.syncStatus} Component={SyncStatus} exact />
      <PageWrapper path={routes.syncStatusDetails} Component={SyncStatusDetails} />
      <PageWrapper exact path={routes.projects} Component={Projects} Header={ProjectsHeader} />
      <PageWrapper secure={false} path={routes.login} Component={Login} />
      <PageWrapper secure={false} path={routes.replaceRedirect} Component={ReplaceRedirect} />
      <Redirect path={"*"} to={routes.projects} />
    </Switch>
  );
};
